/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SzkolenieTo } from '../../models/szkolenie-to';

export interface ApiWebSzkoleniaJwDostepneGet$Params {
}

export function apiWebSzkoleniaJwDostepneGet(http: HttpClient, rootUrl: string, params?: ApiWebSzkoleniaJwDostepneGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SzkolenieTo>>> {
  const rb = new RequestBuilder(rootUrl, apiWebSzkoleniaJwDostepneGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SzkolenieTo>>;
    })
  );
}

apiWebSzkoleniaJwDostepneGet.PATH = '/api/web/szkolenia_jw/dostepne';
